import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { MoreHorizontal } from "lucide-react";

export function SidePanel({ open, onClose, title, sub, children, testid = "le-side-panel" }) {
  return (
    <Sheet open={open} onOpenChange={(o) => !o && onClose()}>
      <SheetContent side="right" className="w-full sm:max-w-xl overflow-y-auto p-5 sm:p-6 [&>button]:text-stone-500 [&>button]:bg-[#F3F1EC] [&>button]:rounded-full [&>button]:p-1.5 [&>button]:opacity-100 [&>button[data-state=open]]:bg-[#F3F1EC] [&>button[data-state=open]]:text-stone-500 [&>button:focus]:ring-[#D6D3D1] [&>button:hover]:bg-[#EBE8E3] [&>button:hover]:text-stone-900" data-testid={testid}>
        <SheetHeader className="text-left mb-4"><SheetTitle className="text-lg text-[#1A1919]">{title}</SheetTitle>{sub && <p className="text-sm text-stone-500">{sub}</p>}</SheetHeader>
        {children}
      </SheetContent>
    </Sheet>
  );
}

export function DotsMenu({ items, testid, className = "", align = "end" }) {
  const list = (items || []).filter(Boolean);
  if (!list.length) return null;
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button type="button" className={`h-7 w-7 rounded-md inline-flex items-center justify-center text-stone-400 hover:text-stone-800 hover:bg-[#F3F1EC] ${className}`} data-testid={testid} aria-label="Menu"><MoreHorizontal className="h-4 w-4" /></button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align={align} className="rounded-xl min-w-[10rem]">
        {list.map(([label, fn, cls, tid]) => <DropdownMenuItem key={label} onClick={fn} className={`text-sm cursor-pointer ${cls || ""}`} data-testid={tid}>{label}</DropdownMenuItem>)}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export function LineRow({ icon: Icon, title, meta, onOpen, openLabel = "Åbn", menu, testid, badge }) {
  return (
    <div className="flex items-center gap-3 px-3.5 py-2.5 hover:bg-[#FBFAF8] transition-colors" data-testid={testid}>
      {Icon && <Icon className="h-4 w-4 text-stone-500 shrink-0" strokeWidth={1.8} />}
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium text-[#1A1919] truncate">{title}</p>
        {meta && <p className="text-xs text-stone-500 truncate">{meta}</p>}
      </div>
      {badge}
      {onOpen && <button type="button" onClick={onOpen} className="text-sm font-medium text-[#1A1919] hover:underline shrink-0" data-testid={testid ? `${testid}-open` : undefined}>{openLabel}</button>}
      {menu && <DotsMenu items={menu} testid={testid ? `${testid}-menu` : undefined} />}
    </div>
  );
}

export const LineList = ({ children, testid }) => <div className="bg-white rounded-2xl border border-[#EBE8E3] divide-y divide-[#F0EDE8] overflow-hidden" data-testid={testid}>{children}</div>;
